'use client'

import { CustomerChatSocketProvider } from "@/lib/customerChatSocketProvider"
import { SessionProvider } from "next-auth/react"

export default function Provider({ children, session }) {
  return (
    <SessionProvider session={session}>
      <CustomerChatSocketProvider>
        {children}
      </CustomerChatSocketProvider>
    </SessionProvider>
  )
}